import React, { useEffect, useState } from "react";
import { Box, Card } from "@mui/material";
import {
  FilterBar,
  IncomeOverviewChart,
  StatsCards,
  TableDemo,
  UniqueVisitorChart,
} from "./components";
import { Header } from "components/Layouts/components";
import { useBDS, useUser } from "hooks";

const Home = () => {
  const { ptype } = useUser()
  const [stateSale, setStateSale] = useState({})
  const [wardSales, setWardSales] = useState([])
  const [changeStatus, setChangeStatus] = useState("")

  const [data, setDate] = useState([])
  const [dataSale, setDateSales] = useState([])
  const { onStatsAll, onGetStats } = useBDS()

  useEffect(() => {
    onStatsAll(ptype, ({ stats_status, stats_sales }) => {
      setDate(stats_status ?? [])
      setDateSales(stats_sales)
    });
    onGetStats(ptype, data => {
      console.log("🚀 ~ useEffect ~ data:", data)
      setStateSale(data)
      // setWardSales(data?.ward_sales)
      const arr = Object.entries(data?.ward_sales).map(([k, v]) => ({ id: v, name: `${k} - ${v}` }))
      setWardSales(arr)
    })

  }, [ptype])


  return (
    <Box>
      <Header namePage="不動産情報自動報告システム" />
      <Box p={3}>
        <Box sx={{ display: "flex", gap: 3 }}>
          <Box sx={{ flex: 1 }}>
            <Card>
              <UniqueVisitorChart data={data?.['list_sold'] ?? []} title={'成約物件'} />
            </Card>
          </Box>
          <Box sx={{ flex: 1 }}>
            <UniqueVisitorChart data={data?.['list_remain'] ?? []} title={'先月残掲載物件'} />
            {/* {stateSale?.num_sold} 掲載物件 */}
          </Box>
          <Box sx={{ flex: 1 }}>
            <UniqueVisitorChart data={data?.['list_new'] ?? []} title={'新着物件'} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <UniqueVisitorChart data={data?.['list_suumo'] ?? []} title={'SUUMOの掲載中物件'} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ px: 3 }}>
        <StatsCards onWardSales={el => {
          const arr = Object.entries(el).map(([k, v]) => ({ id: v, name: `${k} - ${v}` }))
          setWardSales(arr)
        }} />
      </Box>
      <Box px={3} mt={3}>
        <Box sx={{ display: "flex", gap: 3 }}>
          <Box sx={{ flex: 1 }}>
            <IncomeOverviewChart data={dataSale} />
          </Box>
        </Box>

        <Box sx={{ flex: 1, my: 3 }}>
          <FilterBar wardSales={wardSales} onChangeStatus={v => {
            console.log("🚀 ~ Home ~ v:", v)
            setChangeStatus(v)
          }} />
        </Box>
        <TableDemo ptype={ptype} changeStatus={changeStatus} />
      </Box>
    </Box>
  );
};

export default Home;
